<div class="payment-shell">
  <div class="payment-header">
    <h1>{{ "PaymentDetail.texto" | translate }}</h1>

    <div class="language-switch">
      <span>{{ "SwitchLanguage.texto" | translate }}:</span>
      <div class="lang-buttons">
        <button
          class="lang-button"
          (click)="switchLanguage('es')"
          [disabled]="translate.currentLang === 'es'"
          [class.active]="translate.currentLang === 'es'"
          >
          {{ "Spanish.texto" | translate }}
        </button>
        <button
          class="lang-button"
          (click)="switchLanguage('en')"
          [disabled]="translate.currentLang === 'en'"
          [class.active]="translate.currentLang === 'en'"
          >
          {{ "English.texto" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="payment-card">
    <div class="payment-sheet">
      <div class="flex-column">
        <span class="input-header">{{ "FullName.texto" | translate }}</span>
        <span
          class="input"
          [class.input-placeholder]="!userFullName"
          >
          {{
          userFullName || ("UnknownUser.texto" | translate)
          }}
        </span>
      </div>

      <div class="flex-column">
        <span class="input-header">
          {{ "ServiceDescription.texto" | translate }}
        </span>
        <span
          class="input"
          [class.input-placeholder]="!paymentOrder?.name && !paymentOrder?.description"
          >
          {{
          paymentOrder?.name ||
          paymentOrder?.description ||
          ("ServiceDescriptionFallback.texto" | translate)
          }}
        </span>
      </div>

      <div class="flex-row">
        <div class="flex-column">
          <span class="input-header">{{ "ServicePrice.texto" | translate }}</span>
          <span class="input" [class.input-placeholder]="!displayUnitPrice">
            {{ displayUnitPrice | number: "1.2-2" }} {{ selectedCurrency }}
          </span>
        </div>
        <div class="flex-column">
          <span class="input-header">{{ "Total.texto" | translate }}</span>
          <span class="input">
            {{ displayTotal | number: "1.2-2" }} {{ selectedCurrency }}
          </span>
        </div>
      </div>

      <span class="input-header">{{ "PaymentMethod.texto" | translate }}</span>
      <div class="flex-row specific">
        <div class="flex-column">
          <span style="color: gray; font-size: 14px">
            {{ "SelectPaymentMethod.texto" | translate }}
          </span>
        </div>
        <div class="flex-column">
          <div class="currency-field" [class.currency-field--disabled]="!multiCurrency">
            <label class="currency-field__label">
              {{ "Currency.texto" | translate }}
              @if (multiCurrency) {
                <span class="required-star">*</span>
              }
            </label>
            <div class="currency-field__control">
              <mat-select
                class="currency-select"
                [(value)]="selectedCurrency"
                (selectionChange)="changeCurrency(true)"
                [disabled]="!multiCurrency"
                [hideSingleSelectionIndicator]="true"
                #currencySelectRef
                >
                @for (c of currencySelect; track c) {
                  <mat-option [value]="c.isoCode">{{ c.isoCode }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
        </div>
      </div>

      <!-- BOTONES -->
      <div class="flex-row flex-button-pay margin-2rem">
        @if (selectedCurrency == 'USD' || selectedCurrency == 'EUR' && checkStripe) {
          <button
            class="button-select button-mobile btn-credit-card"
            [class.btn-active]="method == 'credit' && checkStripe"
            (click)="changeMethod('credit')"
            [disabled]="!checkStripe"
            >
            <mat-icon>tab</mat-icon>
            <span
              class="select-menu ml-5"
              [class.btn-active]="method == 'credit'"
              >
              {{ "CreditCard.texto" | translate }}
            </span>
          </button>
        }

        @if (selectedCurrency == 'VES') {
          <button
            class="button-select button-mobile btn-inmediate-payment"
            [class.btn-active]="method == 'customsvg'"
            (click)="changeMethod('customsvg')"
            >
            <span
              class="custom-svg-icon"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 24px;
            width: 24px;
          "
              >
              <img
                src="/icons/schedule.svg"
                class="svg-icon" alt="">
              </span>
              <span
                class="select-menu ml-5"
                [class.btn-active]="method == 'customsvg'"
                >
                {{ "ImmediatePayment1.texto" | translate }} <br> {{ "ImmediatePayment2.texto" | translate }}
              </span>
            </button>
          }

          @if (selectedCurrency == 'VES' && checkPagomovil && typeOfBank != '') {
            <button
              class="button-select button-mobile btn-c2p"
              [class.btn-active]="method == 'pagomovil'"
              (click)="changeMethod('pagomovil')"
              >
              <img
                src="/icons/mobile_check.svg"
                width="24"
                height="24"
                style="object-fit: contain"
                class="svg-icon"
                />
                <span
                  class="select-menu ml-5"
                  [class.btn-active]="method == 'pagomovil'"
                  >
                  {{ "C2P.texto" | translate }}
                </span>
              </button>
            }

            @if (checkTransfer) {
              <button
                class="button-select button-mobile btn-transfer"
                [class.btn-active]="method == 'bank' && checkTransfer"
                [disabled]="!checkTransfer"
                (click)="changeMethod('bank')"
                >
                <mat-icon matPrefix>swap_horiz</mat-icon>
                <span class="select-menu ml-5 btn-active">
                  {{ "TransferOrDeposit1.texto" | translate }} <br> {{ "TransferOrDeposit2.texto" | translate }}
                </span>
              </button>
            }
          </div>

          <!-- Información para Pago Mercantil -->
          @if (method == 'customsvg') {
            <div
              class="info-mercantil"
              >
              {{ "MercantilTextBegin.texto" | translate }}
              <span style="font-weight: 900">{{
                "MercantilTextBold.texto" | translate
              }}</span>
              {{ "MercantilTextEnd.texto" | translate }}
            </div>
          }

          <!-- Message when no core payment methods are available (Stripe, Transfer/Deposit, C2P) -->
          @if (
            !checkStripe && !checkTransfer && !checkPagomovil && !showMercantilButton
            ) {
            <div
              class="no-data"
              style="margin: 1rem 0; text-align: center"
              >
              {{ "NoPaymentMethodsAvailableContactAdmin.texto" | translate }}
            </div>
          }

          <!-- Transfer Method Section -->
          @if (method == 'bank') {
            <div class="flex-column" style="margin-top: 2rem">
              <span class="input-header" style="font-size: 1.1rem; margin-bottom: 1rem">{{
                "AssociatedAccountsForPayment.texto" | translate
              }}</span>
              <div class="scroll-div-bank width-lista-bancos">
                @if (dataBank.length > 0) {
                  <div
                    class="flex-service margin-2rem width-lista-bancos"
                    >
                    @for (item of dataBank; track item) {
                      <div class="flex-service" style="margin-bottom: 1.5rem;">
                        <div class="flex-service-row" style="gap: 1.5rem; width: 100%;">
                          <div class="flex-column">
                            <label class="bank-label">{{ "BankName.texto" | translate }}</label>
                            <div class="bank-info-box">
                              {{ item.bankName }}
                            </div>
                          </div>
                          <div class="flex-column">
                            <label class="bank-label">{{ "BankData.texto" | translate }}</label>
                            <div class="bank-info-box" [title]="item.accountData">
                              {{ item.accountData }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              <span class="input-header" style="font-size: 1.1rem; margin-bottom: 1rem">{{
                "RegisterData.texto" | translate
              }}</span>
              <div class="flex-row bank-info-sync" [formGroup]="formPaymenBank">
                <div class="flex-column">
                  <span class="input-header"
                    >{{ "ReferenceNumber.texto" | translate }}
                    <span class="required-star">*</span></span
                    >
                    <input
                      type="text"
                      class="input-full-none"
                      placeholder="{{ '123456789' }}"
                      formControlName="numberReference"
                      minlength="10"
                      maxlength="15"
                      pattern="[A-Za-z0-9]{10,15}"
                      style="padding-left:16px"
                      />
                    </div>
                    <div class="flex-column">
                      <span class="input-header"
                        >{{ "ReceivingBankName.texto" | translate }}
                        <span class="required-star">*</span></span
                        >
                        <mat-select
                          class="input-full-none"
                          formControlName="BankName"
                          placeholder="{{ 'ReceivingBankName.texto' | translate }}"
                          >
                          @for (bank of bankName; track bank) {
                            <mat-option [value]="bank.name">
                              {{ bank.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </div>
                    <div
                      class="flex-row bank-info-sync"
                      style="margin-top: 1rem"
                      [formGroup]="formPaymenBank"
                      >
                      <div class="flex-column">
                        <span class="input-header"
                          >{{ "AccountHolder.texto" | translate }}
                          <span class="required-star">*</span></span
                          >
                          <input
                            type="text"
                            class="input-full-none"
                            placeholder="{{ 'AccountHolder.texto' | translate }}"
                            formControlName="accountHolder"
                            style="padding-left:16px;"
                            />
                          </div>
                          <div class="flex-column">
                            <span class="input-header"
                              >{{ "TransferDate.texto" | translate }}
                              <span class="required-star">*</span></span
                              >
                              <mat-form-field
                                appearance="outline"
                                class="input-full-none datepicker-field"
                                >
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  [max]="maxDate"
                                  (click)="picker.open()"
                                  formControlName="dateComplet"
                                  placeholder="dd/mm/yyyy"
                                  readonly
                                  />
                                  <mat-datepicker-toggle
                                    matSuffix
                                    [for]="picker"
                                  ></mat-datepicker-toggle>
                                  <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="flex-column margin-2rem">
                              <span
                                class="input-header"
                                style="font-size: 1.1rem; margin-bottom: 1rem"
                                >{{ "AttachPaymentReceipt.texto" | translate }}</span
                                >
                                <div class="flex-row" style="gap: 1rem; min-width: 100%">
                                  <!-- div con el input -->
                                  <div class="flex-column">
                                    <div class="file-container">
                                      <div class="inside-input">
                                        <mat-icon>cloud_upload</mat-icon>
                                        <label class="label-top">{{
                                          "DragTheFileHere.texto" | translate
                                        }}</label>
                                      </div>
                                      <input
                                        (change)="getFile($event)"
                                        class="file-input"
                                        type="file"
                                        id="myfile"
                                        accept=".pdf,.jpg,.png"
                                        #fileSelect
                                        />
                                      </div>
                                    </div>
                                    <div class="flex-column" style="gap: 12px;">
                                      <span style="font-size: 11px"
                                        >{{ "AllowedFileFormat.texto" | translate }}
                                        <br />
                                        {{ "MaximumFile.texto" | translate }}
                                      </span>
                                      <button class="button-file" (click)="fileSelect.click()">
                                        <mat-icon>upload</mat-icon>
                                        {{ "FileUpload.texto" | translate }}
                                      </button>
                                    </div>
                                  </div>
                                  <!-- div con el nombre del archivo -->
                                  @if (showfile) {
                                    <div class="flex-filename">
                                      <span style="padding-right: 1rem">
                                        {{ "FileName.texto" | translate }} {{ file.name }}</span
                                        >
                                        <mat-icon
                                          title="{{ deleteFileString }}"
                                          class="material-symbols-outlined"
                                          (click)="deleteFile()"
                                          style="cursor: pointer"
                                          >delete</mat-icon
                                          >
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }

                                <!-- PAGO MOVIL -->
                                @if (method == 'pagomovil') {
                                  <div class="flex-column pagomovil-section">
                                    <!-- Bancos disponibles / detalles -->
                                    <!--<div style="width: 100%" *ngIf="typeOfBank != ''">-->
                                    <label class="c2p-label c2p-header">{{ "PaymentDetail.texto" | translate }}</label>
                                    <div class="pagomovil-row row-1" style="margin-top: 1rem">
                                      <!-- Selección de banco -->
                                      <div class="bank-col">
                                        <label class="c2p-label" style="margin-bottom: 10px;">
                                          {{ "SelectBank.texto" | translate }}
                                          <span class="required-star">*</span>
                                        </label>
                                        <mat-form-field class="width-100">
                                          <mat-label>{{ "Select.texto" | translate }}</mat-label>
                                          <mat-select [(value)]="bankSelected" style="color: black">
                                            @for (bank of listOfBanks; track bank) {
                                              <mat-option
                                                [value]="bank.codBanco"
                                                >
                                                {{ bank.nombreBanco }} - ({{ bank.codBanco }})
                                              </mat-option>
                                            }
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                      <!-- Teléfono -->
                                      <div class="phone-col">
                                        <label class="c2p-label" style="margin-bottom: 10px;">
                                          {{ "PhoneNumber.texto" | translate }}
                                          <span class="required-star">*</span>
                                        </label>
                                        <div class="phone-inputs-row">
                                          <mat-form-field class="width-prefix number-code" appearance="outline">
                                            <mat-label style="transform: translateY(-32px);">{{ "PhonePrefix.texto" | translate }}</mat-label>
                                            <mat-select [(ngModel)]="prefixPhoneNumber" name="phonePrefix">
                                              <mat-option value="58412">0412</mat-option>
                                              <mat-option value="58422">0422</mat-option>
                                              <mat-option value="58414">0414</mat-option>
                                              <mat-option value="58424">0424</mat-option>
                                              <mat-option value="58416">0416</mat-option>
                                              <mat-option value="58426">0426</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                          <mat-form-field class="width-100" appearance="fill">
                                            <mat-label>{{ "EnterPhoneNumber.texto" | translate }}</mat-label>
                                            <input
                                              matInput
                                              [(ngModel)]="phoneNumber"
                                              type="text"
                                              maxlength="7"
                                              />
                                              <img
                                                matSuffix
                                                src="/icons/Edit.svg"
                                                width="24"
                                                height="24"
                                                style="object-fit: contain"
                                                >
                                              </mat-form-field>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="pagomovil-row row-2" style="margin-top: 0.5rem">
                                          <!-- Documento de identificación -->
                                          <div class="doc-col">
                                            <label class="c2p-label"style="margin-bottom: 10px;">
                                              {{ "DocumentFrom.texto" | translate }}
                                              <span class="required-star">*</span>
                                            </label>
                                            <div class="doc-inputs-row">
                                              <mat-form-field
                                                class="width-prefix national-code"
                                                appearance="outline"
                                                >
                                                <mat-label>{{ "DocumentType.texto" | translate }}</mat-label>
                                                <mat-select [(ngModel)]="PrefixDni" name="documentPrefix">
                                                  <mat-option value="V">V</mat-option>
                                                  <mat-option value="E">E</mat-option>
                                                  <mat-option value="P">P</mat-option>
                                                  <mat-option value="C">C</mat-option>
                                                  <mat-option value="J">J</mat-option>
                                                  <mat-option value="G">G</mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                              <mat-form-field class="width-100" appearance="fill">
                                                <mat-label>{{ "DocumentNumber.texto" | translate }}</mat-label>
                                                <input matInput [(ngModel)]="dni" type="text" maxlength="16" />
                                                <img
                                                  matSuffix
                                                  src="/icons/Edit.svg"
                                                  width="24"
                                                  height="24"
                                                  style="object-fit: contain"
                                                  >
                                                </mat-form-field>
                                              </div>
                                              @if (!(PrefixDni == 'V' || PrefixDni == 'E')) {
                                                <label
                                                  class="font-10px"
                                                  style="margin-top: 4px; margin-bottom: 0px;"
                                                  >
                                                  {{ "RifDocument.texto" | translate }}
                                                </label>
                                              }
                                            </div>
                                            <!-- Monto -->
                                            <div class="amount-col">
                                              <label class="c2p-label" style="margin-bottom: 10px;">{{ "AmountToCancel.texto" | translate }}</label>
                                              <div class="amount-box">
                                                @if (tasa > 0) {
                                                  <span>
                                                    {{ price * tasa | number }} {{ accountCurrency.isoCode }}
                                                  </span>
                                                }
                                                @if (tasa == 0) {
                                                  <span>
                                                    {{ price | number }} {{ accountCurrency.isoCode }}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                          <!-- OTP -->
                                          <div class="flex-column margin-top-1rem otp-mobile">
                                            <label class="c2p-label" style="margin-bottom: 10px !important"
                                              >{{ "Otp.texto" | translate }}
                                              <span class="required-star">*</span></label
                                              >
                                              <div class="flex-row gap-1rem align-center flex-direction-col">
                                                <mat-form-field class="width-50" appearance="fill">
                                                  <mat-label>{{ "EnterCodeOtp.texto" | translate }}</mat-label>
                                                  <input matInput [(ngModel)]="Otp" maxlength="8" />
                                                  <img
                                                    matSuffix
                                                    src="/icons/Edit.svg"
                                                    width="24"
                                                    height="24"
                                                    style="object-fit: contain"
                                                    >
                                                  </mat-form-field>
                                                  <a
                                                    class="width-49"
                                                    href="https://www.myservy.com/en/otp"
                                                    target="_blank"
                                                    >
                                                    {{ "DynamicPassword.texto" | translate }}
                                                  </a>
                                                </div>
                                              </div>
                                            <!--</div>-->
                                            <!-- Si no hay typeOfBank disponible mostrar mensaje -->
                                            @if (typeOfBank == '') {
                                              <div class="no-data">
                                                <span>{{ "Nopaymentoptionsareavailable.texto" | translate }}</span>
                                              </div>
                                            }
                                          </div>
                                        }
                                        @if (
                                          method == 'credit' && accountCurrency.isoCode == 'USD' && checkStripe
                                          ) {
                                          <div
                                            class="content-info-card"
                                            >
                                            <mat-icon style="padding: 8px">error</mat-icon>
                                            <span>{{ "CreditCardPaymentsForAmountsLess.texto" | translate }}</span>
                                          </div>
                                        }
                                        @if (method == 'credit') {
                                          <div class="flex-column">
                                            <div class="stripe-card-wrapper">
                                              @if (!stripeReady && !stripeInitFailed) {
                                                <div class="stripe-loading">
                                                  {{ "InitializingCard.texto" | translate }}
                                                </div>
                                              }
                                              @if (stripeInitFailed) {
                                                <div class="stripe-loading">
                                                  {{ "CardUnavailable.texto" | translate }}
                                                </div>
                                              }
                                              <img src="/icons/id-card.svg" class="stripe-custom-icon" alt="Card Icon" />
                                              <!-- Only mount the card once a Stripe instance exists: ngx-stripe would
                                                   otherwise fall back to the injected StripeService, which has no
                                                   Stripe object when the publishable key is not known yet. -->
                                              @if (stripe) {
                                                <ngx-stripe-card
                                                  [stripe]="stripe"
                                                  [elementsOptions]="elementsOptions"
                                                  [options]="cardOptions"
                                                  (ready)="onStripeCardReady()"
                                                  (load)="onStripeCardReady()"
                                                  class="form-control stripe-card"
                                                ></ngx-stripe-card>
                                              }
                                              <!-- Stripe error display: show decline code and translated message when present -->
                                              @if (stripeErrorCode || stripeErrorMessage) {
                                                <div
                                                  class="stripe-error-block"
                                                  >
                                                  <div class="stripe-error-content">
                                                    @if (stripeErrorCode) {
                                                      <div class="stripe-error-code">
                                                        {{ stripeErrorCode }}
                                                      </div>
                                                    }
                                                    @if (stripeErrorMessage) {
                                                      <div class="stripe-error-message">
                                                        {{ stripeErrorMessage | translate }}
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        }

                                        <!-- Action Button: Render always for visibility, but disable unless a method is selected
                                        This avoids the button disappearing in transient states (currency change, async loads)
                                        -->
                                        @if (
                                          method == 'credit' ||
                                          method == 'bank' ||
                                          method == 'pagomovil' ||
                                          method == 'customsvg' ||
                                          method == 'cash' ||
                                          method == 'paypal'
                                          ) {
                                          <div
                                            class="pay-action-container"
                                            >
                                            <button
                                              class="pay-action-button"
                                              (click)="onPayClick($event)"
                                              title="{{ !method ? ('SelectPaymentMethod.texto' | translate) : '' }}"
                                              >
                                              {{ "MakePayment.texto" | translate }}
                                            </button>
                                          </div>
                                        }
                                      </div>

                                      @if (mostrarSpinner) {
                                        <div class="spinner-overlay">
                                          <mat-spinner diameter="60"></mat-spinner>
                                        </div>
                                      }
